import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './supplier.reducer';

export const SupplierDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const supplierEntity = useAppSelector(state => state.supplier.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="supplierDetailsHeading">
          <Translate contentKey="crawlerBackendApp.supplier.detail.title">Supplier</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{supplierEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="crawlerBackendApp.supplier.name">Name</Translate>
            </span>
          </dt>
          <dd>{supplierEntity.name}</dd>
          <dt>
            <span id="origin">
              <Translate contentKey="crawlerBackendApp.supplier.origin">Origin</Translate>
            </span>
          </dt>
          <dd>{supplierEntity.origin}</dd>
          <dt>
            <span id="accessToken">
              <Translate contentKey="crawlerBackendApp.supplier.accessToken">Access Token</Translate>
            </span>
          </dt>
          <dd>{supplierEntity.accessToken}</dd>
          <dt>
            <span id="logoURL">
              <Translate contentKey="crawlerBackendApp.supplier.logoURL">Logo URL</Translate>
            </span>
          </dt>
          <dd>{supplierEntity.logoURL}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.supplier.description">Description</Translate>
            </span>
          </dt>
          <dd>{supplierEntity.description}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="crawlerBackendApp.supplier.status">Status</Translate>
            </span>
          </dt>
          <dd>{supplierEntity.status ? 'true' : 'false'}</dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="crawlerBackendApp.supplier.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>
            {supplierEntity.createDate ? (
              <TextFormat value={supplierEntity.createDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="updateDate">
              <Translate contentKey="crawlerBackendApp.supplier.updateDate">Update Date</Translate>
            </span>
          </dt>
          <dd>
            {supplierEntity.updateDate ? (
              <TextFormat value={supplierEntity.updateDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.supplier.organisation">Organisation</Translate>
          </dt>
          <dd>{supplierEntity.organisation ? supplierEntity.organisation.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.supplier.supplierAdmin">Supplier Admin</Translate>
          </dt>
          <dd>{supplierEntity.supplierAdmin ? supplierEntity.supplierAdmin.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.supplier.customers">Customers</Translate>
          </dt>
          <dd>
            {supplierEntity.customers
              ? supplierEntity.customers.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {supplierEntity.customers && i === supplierEntity.customers.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/supplier" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/supplier/${supplierEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SupplierDetail;
